import React, { useState, useRef, useEffect } from 'react';
import SeveritySelector from './SeveritySelector';
import MultiSelectFilter from './MultiSelectFilter';
import './styles/panelFiltros.css';
import { lang } from '../../generales/traduction';
import { useFetch } from '../../../hooks/useFetch';
import { capitalizeFirstLetter } from '../../../utils/utils';
import Action from '../../Action';
import SelectorAdmin from '../../SelectorAdmin';
import MultiSelector from '../../MultiSelector';
import { ta } from 'date-fns/locale';
// import { lang } from '../../generales/traduction';
const FilterPanel = ({ isOpen, severityFilter, setSeverityFilter,
  statusFilter,
  techFilter,
  groupFilter,
  zoneFilter,
  ackFilter,
  ticketFilter, tipoFilter,
  setStatusFilter,
  setTechFilter,
  setGroupFilter,
  setZoneFilter,
  setAckFilter, setTipoFilter,
  setTicketFilter
  , filters, onFilterChange, yourData, buscar_cis, setManttoData, ManttoData, handleShowPopup, setSearchTerm, languaje, mode, user, dataUsers, devices, server, setRegisterIsValid, groupSelected, setData, loading, setLoading, setError, setEditActive, editActive, closCreateCisModal }) => {

  const [isDragging, setIsDragging] = useState(false);
  // // console.log(window)
  const [position, setPosition] = useState({ x: -300, y: 50 }); // Posición inicial en la esquina superior derecha
  const offset = useRef({ x: 0, y: 0 });
  // console.log(position)
  //   const togglePanel = () => {
  //     setIsOpen(!isOpen);
  //   };

  const handleClearFilters = () => {
    // Reset all filters to their initial state
    const defaultFilters = {
      searchTerm: '',
      severities: [],
      statuses: ['PROBLEMA'], // Default value from your HTML
      techs: [],
      groups: [],
      zones: [],
      ack: null,
      ticket: null,
    };
    onFilterChange(defaultFilters);
  };
  // Función para iniciar el arrastre
  const handleMouseDown = (e) => {
    // Evita arrastrar si se hace clic en un elemento interactivo
    if (e.target.closest('button, input, .tag, .options-dropdown div')) {
      return;
    }

    setIsDragging(true);
    const panel = e.currentTarget;
    offset.current.x = e.clientX - panel.offsetLeft;
    offset.current.y = e.clientY - panel.offsetTop;
  };

  // Función para mover el panel
  const handleMouseMove = (e) => {
    if (!isDragging) return;

    var newX = e.clientX - offset.current.x;
    var newY = e.clientY - offset.current.y;
    if (newX > -250) {
      newX = -250
    };
    if ((newY + 500) > window.innerHeight) {
      newY = window.innerHeight - 500
    }


    setPosition({ x: newX, y: newY });
  }
  // Función para detener el arrastre
  const handleMouseUp = () => {
    setIsDragging(false);
  };

  // Hook para agregar y remover los listeners del documento
  useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    } else {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    }

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging]); // Se ejecuta cada vez que el estado de 'isDragging' cambia


  const obtenerFechaActualLocal = () => {
    const ahora = new Date();
    const anio = ahora.getFullYear();
    const mes = String(ahora.getMonth() + 1).padStart(2, '0'); // El mes se cuenta desde 0
    const dia = String(ahora.getDate()).padStart(2, '0');
    const horas = String(ahora.getHours()).padStart(2, '0');
    const minutos = String(ahora.getMinutes()).padStart(2, '0');

    return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
  };
  // console.log(groupSelected)
  const [loadingM, setLoadingM] = useState(false);
  const [IpValid, setIpValid] = useState(true)
  const [LatValid, setLatValid] = useState(true)
  const [LonValid, setLonValid] = useState(true)
  const [matchPassword, setMatchPassword] = useState(false)
  const [disabled, setDisabled] = useState(true)



  // console.log(dataUsers.data)

  // console.log(ManttoData)

  // const tec_list=useFetch('cassia/ci_elements/technologies','','','GET',server)
  const [msgError, setMsgError] = useState("")
  const [listSearchIP, setListSearchIP] = useState(false)
  // const dataCriticalities=useFetch('cassia/group_types','','','GET',server)
  // console.log(dataCriticalities)
  const dataBrands = useFetch('cassia/brands', '', '', 'GET', server)
  const [dataModels, setDataModels] = useState({
    data: [],
    loading: true,
    error: null
  })
  const dataTechs = useFetch('cassia/tech_devices', '', '', 'GET', server)
  const dataProxies = useFetch('zabbix/proxies', '', '', 'GET', server)
  const dataGroups = useFetch('cassia/host_groups/by_type/1', '', '', 'GET', server)//manda el id 1 para grupos
  const dataZones = useFetch('cassia/host_groups/by_type/2', '', '', 'GET', server)//manda el id 2 para zonas  
  // console.log(dataZones)
  const handleChange = (e) => {
    // console.log(e.target.name)
    const { name, value } = e.target
    if (e.target.name === "criticality") {
      setManttoData((prevState) => {
        return {
          ...prevState,
          [name]: value === "" ? 0 : (parseInt(value))
        }

      })
    } if (e.target.name === "host") {
      setManttoData((prevState) => {
        return {
          ...prevState,
          [name]: value.trimStart()
        }

      })
    } else if (e.target.name === "status") {
      setManttoData((prevState) => {
        return {
          ...prevState,
          [name]: (value == 0) ? 1 : 0
        }

      })
    } else {
      setManttoData((prevState) => {
        return {
          ...prevState,
          [name]: value
        }

      })
    }



    if (e.target.name === "agent_ip") {
      if (value == "") {
        setIpValid(true)
      } else {
        // setIpValid(validateIp(value))
      }
    }
    // console.log(e.target.name)
    if (e.target.name === "location_lat") {
      if (value == "") {
        setLatValid(true)
      } else {
        // setLatValid(validarLatitud(value))
      }
    }

    if (e.target.name === "location_lon") {
      if (value == "") {
        setLonValid(true)
      } else {
        //   setLonValid(validarLongitud(value))
      }
    }
  }



  useEffect(() => {

    if (ManttoData.host == "" || ManttoData.name == "" || IpValid == false || LatValid == false || LonValid == false || ManttoData.agent_ip == "" || ManttoData.agent_ip == null ||
      ManttoData.location_lat == "" || ManttoData.location_lon == "" || ManttoData.groupids.length == 0

    ) {
      // console.log('disabled')
      setDisabled(true)
    } else {
      // console.log('no disabled')
      setDisabled(false)
    }
  }, [ManttoData])
  const changeOption = (option, index) => {
    // console.log(option.filter,option,index)
    let attr = ""
    if (option.length != 0) {
      if (option[0].filter == "techDevices") {
        setTechFilter(option)
      } else if (option.filter == "hostModel") {
        attr = "model_id"
      } else if (option.filter == "techDevices") {
        attr = "device_id"
      } else if (option.filter == "proxy") {
        attr = "proxy_id"
      } else if (option.filter == "Grupos") {
        attr = "zona_groupid"
      }
    }


    // setManttoRelation(option.value)

  }
  const changeMultiOption = (option, index, titulo) => {
    let attr = ""
    if (titulo == "techDevices") {
      setTechFilter(option)
    }
    if (titulo == "Grupos") {
      setGroupFilter(option)
    }

    if (titulo == "zona") {
      setZoneFilter(option)
    }


    // setManttoData((prevState)=>{
    //     return {
    //         ...prevState,
    //         [attr]:option.map(item => item.value)
    //     }

    // })
  }
  // const [severityOptions ,setSeverityOptions] = useState([])
  //  console.log(severityFilter)
  const handleSeverity = (option) => {
    let newSelection;
    if (severityFilter.includes(option)) {
      // Si la opción ya está seleccionada, la removemos del array.
      newSelection = severityFilter.filter((val) => val !== option);
    } else {
      // Si la opción no está seleccionada, la agregamos al array.
      newSelection = [...severityFilter, option];
    }
    // Llama a la función del padre para actualizar el estado.
    setSeverityFilter(newSelection);
  };
  // const [statusOption ,setStatusOption] = useState(['PROBLEM' ,'RESOLVED'])
  //  console.log(statusFilter)
  const handleStatus = (option) => {
    let newSelection;
    if (statusFilter.includes(option)) {
      // Si la opción ya está seleccionada, la removemos del array.
      newSelection = statusFilter.filter((val) => val !== option);
    } else {
      // Si la opción no está seleccionada, la agregamos al array.
      newSelection = [...statusFilter, option];
    }
    // Llama a la función del padre para actualizar el estado.
    setStatusFilter(newSelection);
  };
  const handleAck = (option) => {
    let newSelection;
    if (ackFilter.includes(option)) {
      // Si la opción ya está seleccionada, la removemos del array.
      newSelection = ackFilter.filter((val) => val !== option);
    } else {
      // Si la opción no está seleccionada, la agregamos al array.
      newSelection = [...ackFilter, option];
    }
    // Llama a la función del padre para actualizar el estado.
    setAckFilter(newSelection);
  };
  const handleTicket = (option) => {
    let newSelection;
    if (ticketFilter.includes(option)) {
      // Si la opción ya está seleccionada, la removemos del array.
      newSelection = ticketFilter.filter((val) => val !== option);
    } else {
      // Si la opción no está seleccionada, la agregamos al array.
      newSelection = [...ticketFilter, option];
    }
    // Llama a la función del padre para actualizar el estado.
    setTicketFilter(newSelection);
  };
  const handleTipo = (option) => {
    let newSelection;
    if (tipoFilter.includes(option)) {
      // Si la opción ya está seleccionada, la removemos del array.
      newSelection = tipoFilter.filter((val) => val !== option);
    } else {
      // Si la opción no está seleccionada, la agregamos al array.
      newSelection = [...tipoFilter, option];
    }
    // Llama a la función del padre para actualizar el estado.
    setTipoFilter(newSelection);
  };
  const {
    host,
    name,
    proxy_id,
    description,
    status,
    device_id,
    alias,
    location_lat,
    location_lon,
    serialno_a,
    macaddress_a,
    brand_id,
    model_id,
    agent_ip,
    agent_port,
    snmp_ip,
    snmp_port,
    snmp_version,
    snmp_community,
    groupids,
    zona_groupid } = ManttoData;
  return (
    <div>
      {/* <button onClick={togglePanel}>Filtros</button> */}
      {isOpen && (
        <div className="filter-panel "
          style={{
            left: `${position.x}px`,
            top: `${position.y}px`,
            cursor: isDragging ? 'grabbing' : 'grab' // Cambia el cursor
          }}
          onMouseDown={handleMouseDown}>

          <div className="form-GS-box">



            <div className="user-box-GS" style={{ height: '20%' }}>

              <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['severidad'])}</label>
              <div class="severity-selector" id="severidad-selector">
                <button class={"severity-btn " + (severityFilter.includes(1) ? 'active' : '')} data-value="1" onClick={() => handleSeverity(1)}>1</button>
                <button class={"severity-btn " + (severityFilter.includes(2) ? 'active' : '')} data-value="2" onClick={() => handleSeverity(2)}>2</button>
                <button class={"severity-btn " + (severityFilter.includes(3) ? 'active' : '')} data-value="3" onClick={() => handleSeverity(3)}>3</button>
                <button class={"severity-btn " + (severityFilter.includes(4) ? 'active' : '')} data-value="4" onClick={() => handleSeverity(4)}>4</button>
                <button class={"severity-btn " + (severityFilter.includes(5) ? 'active' : '')} data-value="5" onClick={() => handleSeverity(5)}>5</button>
                <button class={"severity-btn " + (severityFilter.includes(6) ? 'active' : '')} data-value="6" onClick={() => handleSeverity(6)}>ODD</button>
              </div>
            </div>

            <div className="user-box-GS" style={{ height: '20%' }}>

              <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['estatus'])}</label>
              <div class="severity-selector" id="status-selector">
                <button class={"severity-btn " + (statusFilter.includes('PROBLEM') ? 'active' : '')} data-value="PROBLEMA" onClick={() => handleStatus('PROBLEM')}>{capitalizeFirstLetter(lang[languaje]['problema'])}</button>
                <button class={"severity-btn " + (statusFilter.includes('RESOLVED') ? 'active' : '')} data-value="RESUELTO" onClick={() => handleStatus('RESOLVED')}>{capitalizeFirstLetter(lang[languaje]['resuelto'])}</button>
              </div>
            </div>



            <div className="user-box-GS " style={{ height: 'auto', minHeight: '20%' }}>
              {
                (dataTechs.loading) ? <p style={{ color: 'var(--txt-color)' }}> {capitalizeFirstLetter(lang[languaje]['CargandoDatos'])} . . .</p> :
                  <MultiSelector placeholder={capitalizeFirstLetter(lang[languaje]['seleccionarTecnologia']) + '...'} opGeneral={true} txtOpGen={''} opt_de={techFilter.map(item => item.id)} origen={'Admin'} data={dataTechs.data.data} loading={dataTechs.loading} titulo='techDevices' selectFunction={changeMultiOption} index={0}></MultiSelector>
              }
              <label className='label-GS'>{capitalizeFirstLetter(lang[languaje]['tecnologia'])}</label>
            </div>

            <div className="user-box-GS" style={{ height: 'auto', minHeight: '20%' }}>
              {/* <input required name="groupids"  type="text" value={groupids}
                                    onChange={handleChange} disabled /> */}
              {
                (dataGroups.loading) ? <p style={{ color: 'var(--txt-color)' }}> {capitalizeFirstLetter(lang[languaje]['CargandoDatos'])} . . .</p> :
                  <MultiSelector placeholder={capitalizeFirstLetter(lang[languaje]['seleccionarGrupo']) + '...'} opGeneral={false} txtOpGen={''} opt_de={groupFilter.map(item => item.id)} origen={'Admin'} data={dataGroups.data.data} loading={dataGroups.loading} titulo='Grupos' selectFunction={changeMultiOption} index={0}></MultiSelector>
              }
              <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['grupos'])}</label>

            </div>
            <div className="user-box-GS" style={{ height: 'auto', minHeight: '20%' }}>
              {
                (dataZones.loading) ? <p style={{ color: 'var(--txt-color)' }}> {capitalizeFirstLetter(lang[languaje]['CargandoDatos'])} . . .</p> :
                  <MultiSelector placeholder={capitalizeFirstLetter(lang[languaje]['seleccionarZona']) + '...'} opGeneral={true} txtOpGen={''} opt_de={zoneFilter.map(item => item.id)} origen={'Admin'} data={dataZones.data.data} loading={dataZones.loading} titulo='zona' selectFunction={changeMultiOption} index={0}></MultiSelector>
              }
              <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['zona']) + " / " + capitalizeFirstLetter(lang[languaje]['municipio'])}</label>

            </div>
            <div className="user-box-GS" style={{ height: '20%' }}>
              {/* <input required name="alias"  type="text" value={alias}
                                    onChange={handleChange}  /> */}
              <label className='label-GS  '>{'Acuse (Ack)'}</label>
              <div class="severity-selector" id="ack-selector">
                <button class={"severity-btn " + (ackFilter.includes(1) ? 'active' : '')} data-value="true" onClick={() => handleAck(1)}>{capitalizeFirstLetter(lang[languaje]['conAck'])}</button>
                <button class={"severity-btn " + (ackFilter.includes(0) ? 'active' : '')} data-value="false" onClick={() => handleAck(0)}>{capitalizeFirstLetter(lang[languaje]['sinAck'])}</button>
              </div>
            </div>
            <div className="user-box-GS" style={{ height: '20%' }}>
              {/* <input required name="location_lat" maxlength={9} placeholder=' valores >= -90  y <= 90°     ejemplo:(20.000)' type="text" value={location_lat}
                                    onChange={handleChange}  /> */}
              <label className='label-GS  '>{'Ticket'}</label>
              <div class="severity-selector" id="ticket-selector">
                <button class={"severity-btn " + (ticketFilter.includes(1) ? 'active' : '')} data-value="true" onClick={() => handleTicket(1)}>{capitalizeFirstLetter(lang[languaje]['conTicket'])}</button>
                <button class={"severity-btn " + (ticketFilter.includes(0) ? 'active' : '')} data-value="false" onClick={() => handleTicket(0)}>{capitalizeFirstLetter(lang[languaje]['sinTicket'])}</button>
              </div>
            </div>
            <div className="user-box-GS" style={{ height: '20%' }}>
              {/* <input required name="location_lat" maxlength={9} placeholder=' valores >= -90  y <= 90°     ejemplo:(20.000)' type="text" value={location_lat}
                                    onChange={handleChange}  /> */}
              <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['tipo'])}</label>
              <div class="severity-selector" id="Tipo-selector" >
                <button class={"severity-btn " + (tipoFilter.includes('workflow') ? 'active' : '')} data-value="true" onClick={() => handleTipo('workflow')}>WorkFlow</button>
                <button class={"severity-btn " + (tipoFilter.includes('correlation') ? 'active' : '')} data-value="false" onClick={() => handleTipo('correlation')}>{capitalizeFirstLetter(lang[languaje]['correlacion'])}</button>
                {/* <button class={"severity-btn "+(tipoFilter.includes('camera_sd')?'active':'')} data-value="false" onClick={() => handleTipo('camera_sd')}>Camera_SD</button>
                  <button class={"severity-btn "+(tipoFilter.includes('reset')?'active':'')} data-value="false" onClick={() => handleTipo('reset')}>Reset</button> */}
              </div>

            </div>















          </div>
        </div>
      )}
    </div>
  );
};

export default FilterPanel;